import firebase from '@/firebase'
const functions = firebase.functions

const state = {
  // Shared plan view
  simulationId: null,
  simulationObject: null,
  clientId: null,
  clientObject: null,
  // Shared model report view
  modelReportClientId: null,
  modelReportClientObject: null
}

const getters = {
  simulationId: state => {
    return state.simulationId
  },
  simulationObject: state => {
    return state.simulationObject
  },
  clientId: state => {
    return state.clientId
  },
  clientObject: state => {
    return state.clientObject
  },
  modelReportClientId: state => {
    return state.modelReportClientId
  },
  modelReportClientObject: state => {
    return state.modelReportClientObject
  }
}

const actions = {
  // Shared plan view
  async getSharedPlan (context, payload) {
    try {
      const result = await functions.httpsCallable('shared-getSharedPlan')({
        shareId: payload.shareId
      })
      context.commit('setSimulationId', {
        simulationId: result.data.simulationId
      })
      context.commit('setSimulationObject', {
        simulationObject: {
          ...result.data.simulationObject,
          id: result.data.simulationId,
          results: JSON.parse(result.data.simulationObject.results)
        }
      })
      context.commit('setClientId', {
        clientId: result.data.clientId
      })
      context.commit('setClientObject', {
        clientObject: result.data.clientObject
      })
    } catch (error) {
      throw error
    }
  },
  // Shared plan management
  async getSharePlanLink (context, payload) {
    return new Promise(async (resolve, reject) => {
      let shareCode
      try {
        const docs = await firebase.firestore()
          .collection('shared')
          .where('client', '==', payload.clientId)
          .where('simulation', '==', payload.planId)
          .limit(100)
          .get()
        if (!docs.empty) {
          shareCode = docs.docs[0].id
        } else {
          console.log('No existing share detected.')
        }
      } catch (error) {
        console.log('No existing share detected.')
      }
      if (!shareCode && payload.generate) {
        const docRef = await firebase.firestore().collection('shared').add({
          client: payload.clientId,
          simulation: payload.planId,
          uid: payload.uid,
          created: firebase.firestore.FieldValue.serverTimestamp()
        })
        if (docRef.id) {
          shareCode = docRef.id
        }
      }
      if (shareCode) {
        resolve(
          {
            link: `https://${payload.hostname}/sharedPlan/${shareCode}/`,
            shareId: shareCode
          }
        )
      } else {
        resolve()
      }
    })
  },
  async deleteSharePlanLink (context, payload) {
    try {
      await firebase.firestore()
        .collection('shared')
        .doc(payload.shareId)
        .delete()
      console.log('Share link deleted successfully')
    } catch (error) {
      console.error('Error deleting share link:', error)
      throw error
    }
  },
  // Shared model report view
  async getSharedModelReport (context, payload) {
    try {
      const result = await functions.httpsCallable('shared-getSharedModelReport')({
        shareId: payload.shareId
      })
      context.commit('setModelReportClientId', {
        clientId: result.data.clientId
      })
      // Parse model_report if it's a string
      let clientObject = result.data.clientObject
      if (clientObject.model_report && typeof clientObject.model_report === 'string') {
        clientObject = {
          ...clientObject,
          model_report: JSON.parse(clientObject.model_report)
        }
      }
      context.commit('setModelReportClientObject', {
        clientObject: clientObject
      })
    } catch (error) {
      throw error
    }
  },
  // Shared model report management
  async getShareModelReportLink (context, payload) {
    return new Promise(async (resolve, reject) => {
      let shareCode
      try {
        const docs = await firebase.firestore()
          .collection('shared')
          .where('client', '==', payload.clientId)
          .where('type', '==', 'modelReport')
          .limit(100)
          .get()
        if (!docs.empty) {
          shareCode = docs.docs[0].id
        } else {
          console.log('No existing model report share detected.')
        }
      } catch (error) {
        console.log('No existing model report share detected.')
      }
      if (!shareCode && payload.generate) {
        const docRef = await firebase.firestore().collection('shared').add({
          client: payload.clientId,
          type: 'modelReport',
          uid: payload.uid,
          created: firebase.firestore.FieldValue.serverTimestamp()
        })
        if (docRef.id) {
          shareCode = docRef.id
        }
      }
      if (shareCode) {
        resolve(
          {
            link: `https://${payload.hostname}/sharedModelReport/${shareCode}/`,
            shareId: shareCode
          }
        )
      } else {
        resolve()
      }
    })
  },
  async deleteShareModelReportLink (context, payload) {
    try {
      await firebase.firestore()
        .collection('shared')
        .doc(payload.shareId)
        .delete()
      console.log('Model report share link deleted successfully')
    } catch (error) {
      console.error('Error deleting model report share link:', error)
      throw error
    }
  }
}

const mutations = {
  setSimulationId (state, payload) {
    state.simulationId = payload.simulationId
  },
  setSimulationObject (state, payload) {
    state.simulationObject = payload.simulationObject
  },
  setClientId (state, payload) {
    state.clientId = payload.clientId
  },
  setClientObject (state, payload) {
    state.clientObject = payload.clientObject
  },
  setModelReportClientId (state, payload) {
    state.modelReportClientId = payload.clientId
  },
  setModelReportClientObject (state, payload) {
    state.modelReportClientObject = payload.clientObject
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
